import { updateAddressMockHandler } from '@/features/profiles/api/update-address';
import {
  updateProfileMockHandler,
  updateProfileNameMockHandler,
} from '@/features/profiles/api/update-profile';

export const profilesHandlers = [
  updateProfileMockHandler,
  updateProfileNameMockHandler,
  updateAddressMockHandler,
];
